import { createFileRoute } from '@tanstack/react-router';
import { WorkspaceGeneralSettingsPage } from '../components/settings/settings-shell.js';

export const Route = createFileRoute('/$workspaceSlug/settings/general')({
  component: WorkspaceGeneralSettingsPage,
});
